import type { Pricing } from '@/domain/Pricing';
import * as ECAPI from './EcommerceService.ts';
import {
  fromEcapiDto,
  type ProductDetailPricesDTO
} from '@/domain/assemblers/PricingAssembler.ts';
import asyncFailToDefault from '@/utils/asyncFailToDefault.ts';
import type { BasicInfoResponseDTO } from '@/services/generated/ECAPICustomersDTOs.ts';

export async function getPrices(
  market: string,
  channel: string,
  cacheBurst?: boolean
): Promise<Map<string, Pricing>> {
  const customerInfo = await asyncFailToDefault<
    BasicInfoResponseDTO | undefined
  >(
    ECAPI.customerInfo(market, channel, cacheBurst),
    undefined // User is not logged in
  );

  let pricesResponse;
  if (customerInfo) {
    pricesResponse = await ECAPI.productPrices(
      market,
      channel,
      customerInfo.taxSystem,
      customerInfo.tariff,
      customerInfo.currency,
      cacheBurst
    );
  } else {
    pricesResponse = await ECAPI.productPrices(
      market,
      channel,
      undefined,
      undefined,
      undefined,
      cacheBurst
    );
  }

  return new Map<string, Pricing>(
    pricesResponse.prices?.map((item) => [
      item.productId as string,
      fromEcapiDto(item as ProductDetailPricesDTO)
    ]) ?? []
  );
}
